// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DOjK","right":"styles_right__htCw4"};